import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.css']
})
export class TopBannerComponent implements OnInit {

  @Input() btnLink: string;
  @Input() btnClass: string;
  @Input() backgroundClass: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() imgSrc: string;
  @Input() buttonText: string;
  @Input() height: number;


  constructor() { }

  ngOnInit(): void {
    console.log(this.backgroundClass);
  }

}
